import { FC, ReactText } from "react";

import "./TagSwitch.css";

export interface TagSwitchOption {
  value: ReactText;
  label?: ReactText;
}

export interface TagSwitchProps {
  options: TagSwitchOption[];
  selected?: ReactText;
  onChange: (value: ReactText) => void;
}

export const TagSwitch: FC<TagSwitchProps> = ({ options, onChange, selected = options[0] }) => (
  <div className="tag-switch">
    {options.map(({ value, label = value }) => {
      if (value === selected) {
        return <span className="tag-switch__item tag-switch__item--selected" key={value}>{label}</span>
      }

      return <button className="tag-switch__item" onClick={() => onChange(value)} key={value}>{label}</button>
    })}
  </div>
)